import React, { Component } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import { Input, Checkbox } from "semantic-ui-react";
import "./TagClientModal.scss";
import { toast } from "react-toastify";
import Modal from "../../../UIComponents/CustomModal/Modal";

class TagClientModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tagged_clients: [],
            untagged_clients: [],
            client_search: "",
        };
    }
    UNSAFE_componentWillUpdate(newProps) {
        if (newProps.data !== this.props.data) {
            let company_list = newProps.active_company_list.map((key) => {
                return key.key;
            });
            let tagged_clients_arr = newProps.data ? newProps.data._source.company_ids : "";
            this.setState({ tagged_clients: tagged_clients_arr });
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.open === true && this.props.open === false) {
            if (this.props.active_company_list.length === 0) this.props.getClients();
            this.setState({
                untagged_clients: [],
                client_search: "",
            });
        }
    }
    symmetricDifference = (a1, a2) => {
        let result = [];
        for (let i = 0; i < a1.length; i++) {
            if (a2.indexOf(a1[i]) === -1) {
                result.push(a1[i]);
            }
        }
        for (let i = 0; i < a2.length; i++) {
            if (a1.indexOf(a2[i]) === -1) {
                result.push(a2[i]);
            }
        }
        return result;
    };

    compare = (a, b) => {
        // for arranging checkboxes in alphabetical order
        const textA = a.text.toUpperCase();
        const textB = b.text.toUpperCase();
        let comparison = 0;
        if (textA > textB) {
            comparison = 1;
        } else if (textA < textB) {
            comparison = -1;
        }
        return comparison;
    };

    handleClientChange = (v) => {
        if (!this.state.tagged_clients.includes(v.value)) {
            if (this.state.untagged_clients.includes(v.value)) {
                let temp = this.state.untagged_clients;
                let ind = temp.indexOf(v.value);
                temp.splice(ind, 1);
                this.setState({ untagged_clients: temp });
            } else {
                let temp = this.state.untagged_clients;
                temp.push(v.value);
                this.setState({ untagged_clients: temp });
            }
        }
    };

    handleSearchChange = (d) => {
        this.setState({ client_search: d.value });
    };

    searched = (x) => {
        if (this.state.client_search === "") return true;
        let includes = false;
        if (x.text.toLowerCase().includes(this.state.client_search.toLowerCase())) {
            includes = true;
        }
        return includes;
    };

    getCheckBoxes = () => {
        // let company_list = this.props.active_company_list.map((key) => {
        //     return key.key;
        // });
        // console.log(company_list);
        // let tagged_clients = this.props.data ? this.props.data._source.company_ids : "";
        // let untagged_clients = this.symmetricDifference(tagged_clients, company_list);

        let active_company_list = this.props.active_company_list.sort(this.compare);

        return active_company_list
            .filter((x) => this.searched(x))
            .map((option) => (
                <Checkbox
                    onChange={(e, value) => this.handleClientChange(value)}
                    key={option.value}
                    label={{ children: option.text }}
                    value={option.value}
                    style={{ display: "block" }}
                    checked={this.state.tagged_clients.indexOf(option.value) != -1 || this.state.untagged_clients.indexOf(option.value) != -1 ? true : false}
                    className={this.state.tagged_clients.indexOf(option.value) != -1 ? "checked disabled cmpny_chkbox" : "cmpny_chkbox"}
                />
            ));
    };

    getSelectedCheckBoxes = () => {
        let selected_clients = this.state.tagged_clients.concat(this.state.untagged_clients);
        let selectedClientsData = [];
        for (let i = 0; i < selected_clients.length; i++) {
            for (let j = 0; j < this.props.active_company_list.length; j++) {
                if (selected_clients[i] == this.props.active_company_list[j].key) {
                    selectedClientsData.push(this.props.active_company_list[j]);
                }
            }
        }
        return selectedClientsData.map((option, index) => <li key={index}>{option.text}</li>);
    };

    tagClient = () => {
        let cmpny_checked_list = this.state.untagged_clients;
        if (!this.state.untagged_clients.length) {
            toast.error("Please select atleast one company");
            return;
        }
        let _id = this.props.data._index + ":" + this.props.data._id;
        this.props.tagClient(_id, cmpny_checked_list);
        this.props.hideModal();
    };
    render() {
        // console.log(this.props.active_company_list);
        return (
            <Modal className={`tag-client-modal`} show={this.props.open} onClose={() => this.props.hideModal()}>
                <Modal.Header>Tag Clients</Modal.Header>
                <Modal.Content>
                    <div className="left-container">
                        <Input icon="search" placeholder="Search..." value={this.props.filterSearch} onChange={(e, d) => this.handleSearchChange(d)} />
                        <div className="options">
                            {this.props.active_company_list.length > 0 && this.props.data && (
                                <Scrollbars autoHide className="">
                                    {this.getCheckBoxes()}
                                </Scrollbars>
                            )}
                        </div>
                    </div>
                    <div className="right-container">
                        <div className="selected-header">
                            <span>Selected Clients</span>
                        </div>
                        {this.props.data && (
                            <Scrollbars autoHide className="">
                                <ul className="selected_clients">{this.getSelectedCheckBoxes()}</ul>
                            </Scrollbars>
                        )}
                    </div>
                </Modal.Content>
                <Modal.Actions>
                    <Modal.ActionButton normal onClick={() => this.props.hideModal()}>
                        Cancel
                    </Modal.ActionButton>
                    <Modal.ActionButton filled onClick={() => this.tagClient()}>
                        Save
                    </Modal.ActionButton>
                </Modal.Actions>
            </Modal>
        );
    }
}

export default TagClientModal;
